module.exports = __webpack_public_path__ + "img/Trillionaire-4.4f587793.gif";